// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3reTv","tab":"ProcedureTabs_tab__bOaQN"};